var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD0423F2-B239-4E47-9621-B6938951799F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.8%",
    y: "-13.3%",
    width: "135.6%",
    height: "135.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Helix-Template-1.9B",
    transform: "translate(-103.000000, -1025.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-243",
    transform: "translate(108.000000, 1028.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.4110951,18.5970876 L19.4110951,27.5869438 C22.0898904,26.0817864 24.7340164,24.5961375 27.4110951,23.0919823 C24.7197368,21.5798767 22.0844669,20.0991717 19.4110951,18.5970876 M20.874272,12.5453248 L24.1009091,12.5453248 C24.7645665,12.6264987 25.4281553,12.6349835 26.0918128,12.5453248 L26.435072,12.5453248 C26.438024,12.5989063 26.4703591,12.6224901 26.5221226,12.6214212 C27.7096623,12.5971692 28.8928083,12.6894335 30.0776706,12.7422132 C31.4882602,12.8050812 32.8927398,12.8958089 34.2873335,13.1376603 C35.9301723,13.4225371 37.079473,14.6561796 37.4000771,16.1866579 C37.7923538,18.0594694 37.8833175,19.9644832 37.948674,21.8681609 C37.9967303,23.2671575 37.9554706,24.6655529 37.8581223,26.0642155 C37.7576159,27.5093777 37.671046,28.952736 37.2826824,30.3597498 C36.9545266,31.5487633 36.1821933,32.3649783 35.0307644,32.837457 C34.1481762,33.1996328 33.1939841,33.2369126 32.2581221,33.3145456 C31.1110183,33.4096827 29.9592462,33.4631305 28.8082292,33.4995419 C26.7870501,33.5634788 24.7647725,33.6439846 22.7431814,33.6388402 C19.9683422,33.6316916 17.193297,33.5841898 14.4212726,33.4166309 C13.2732763,33.3472824 12.127271,33.2837463 10.9895725,33.1151852 C9.71347186,32.9261804 8.71197865,32.3237567 8.04598703,31.2357595 C7.59830831,30.5044598 7.48585658,29.6717428 7.37889699,28.8524545 C7.21564289,27.6024437 7.12035412,26.3462195 7.07126805,25.0841161 C6.97714636,22.6602576 7.04559225,20.2450843 7.31422695,17.8349886 C7.39626591,17.0988117 7.48448354,16.3576909 7.73314055,15.6551861 C8.29553652,14.0659152 9.50792821,13.2520386 11.1756876,13.0378465 C13.1654243,12.7823659 15.1686853,12.7118148 17.1726328,12.6432011 C17.6968584,12.6252293 18.2232121,12.660104 18.74579,12.5970356 C19.0293222,12.5973028 19.3131976,12.6059213 19.5963178,12.5958998 C20.0223026,12.5808676 20.4519258,12.6465416 20.874272,12.5453248",
    id: "Fill-1",
    fill: "#FE0001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2812675,18.1703248 C21.1008392,19.8150831 23.8802254,21.4364316 26.7187675,23.0921632 C23.8952859,24.7391894 21.1065593,26.3659514 18.2812675,28.0140748 L18.2812675,18.1703248 Z",
    id: "Fill-4",
    fill: "#FEFBFB"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.005351a7.svg";
export { ForwardRef as ReactComponent };